/**
 * Fecha actual en Colombia (YYYY-MM-DD).
 */
export function colombiaTodayString() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Bogota' }).format(new Date());
}

/**
 * Formatea una fecha calendario (YYYY-MM-DD o ISO) sin desfase por zona horaria.
 */
export function formatDateOnly(value) {
  if (value == null || value === '') return null;
  const datePart = String(value).split('T')[0];
  const match = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return null;
  const [, year, month, day] = match;
  return `${parseInt(day, 10)}/${parseInt(month, 10)}/${year}`;
}
